import {Heading, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {EngineOilReplacementGroup} from '../../kit/groups/EngineOilReplacementGroup';
import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function EngineOilReplacementSubSection() {
  return (
    <>
      <VFKit.SubSection data-testid="engine-oil-replacement">
        <VStack spacing={4}>
          <Heading size={4}>{i18n.t('entity.vehicle.labels.engineOil')}</Heading>
          <VFKit.Group columns={4} data-testid="engine-oil-replacement-group">
            <EngineOilReplacementGroup />
          </VFKit.Group>
        </VStack>
      </VFKit.SubSection>
    </>
  );
}
